import React, { useState } from "react";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';

const HtmlColorCodes = () => {
  const [color, setColor] = useState("#000000");
  const [hexInput, setHexInput] = useState("#000000");
  const [copied, setCopied] = useState(false);

  const handleColorChange = (event) => {
    const newColor = event.target.value;
    setColor(newColor);
    setHexInput(newColor);
    setCopied(false);
  };

  const handleHexInputChange = (event) => {
    const newHex = event.target.value;
    if (/^#([0-9A-F]{3}){1,2}$/i.test(newHex) || newHex === "") {
      setHexInput(newHex);
      if (newHex.length === 7) {
        setColor(newHex);
        setCopied(false);
      }
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(color);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <>
      <Header />
      <RandomContent />

      <div className="blog-area pb-20" >
        <div className="container-block-fluid">
          <div className="row justify-content-center">

            <div className="full-col col-lg-12 col-md-12">
              <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                <div className="details" style={{ textAlign: 'center' }}>
                  <h1 className="title-heading" style={{ color: '#3d566e', fontWeight: 'bold', marginBottom: '20px' }}>
                    HTML Color Codes
                  </h1>
                  <p className="title-subheading" style={{ color: '#444', fontSize: '16px', lineHeight: '1.7', maxWidth: '720px', margin: '0 auto 40px' }}>
                    Discover and copy HTML color codes effortlessly with Data Beautifier’s free HTML Color Codes tool. Whether you need hex, RGB, or HSL values, our easy-to-use color picker and input make it simple to find the perfect color for your website or design project. No technical skills required — just select, customize, and copy the color codes you need to make your designs pop. Available 24/7 and completely free!
                  </p>
                </div>
              </div>
            </div>

            <div className="full-col col-lg-10 col-md-10">
              <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800"
                style={{
                  display: 'flex',
                  gap: '40px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#fff',
                  padding: '30px',
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  flexWrap: 'wrap'
                }}>

                {/* Color Picker */}
                <div style={{ flex: '1 1 200px', textAlign: 'center' }}>
                  <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold', color: '#3d566e' }}>
                    Choose a Color:
                  </label>
                  <input
                    type="color"
                    value={color}
                    onChange={handleColorChange}
                    style={{
                      width: '90px',
                      height: '90px',
                      border: 'none',
                      cursor: 'pointer',
                      borderRadius: '10px',
                      boxShadow: '0 0 6px rgba(0,0,0,0.2)'
                    }}
                  />
                </div>

                {/* Color Display & Hex Input */}
                <div
                  style={{
                    flex: '1 1 250px',
                    background: color,
                    padding: '25px',
                    borderRadius: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.2)'
                  }}
                >
                  <input
                    type="text"
                    value={hexInput}
                    onChange={handleHexInputChange}
                    maxLength="7"
                    placeholder="#000000"
                    style={{
                      width: '140px',
                      padding: '12px',
                      fontSize: '18px',
                      textAlign: 'center',
                      border: 'none',
                      borderRadius: '6px',
                      marginBottom: '15px',
                      backgroundColor: '#ffffffcc',
                      color: '#333',
                      fontWeight: 'bold',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
                    }}
                  />
                  <button
                    onClick={copyToClipboard}
                    className="default-btn icon four"
                    style={{
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      fontSize: '15px',
                      width: '130px',
                      padding: '10px 0',
                      borderRadius: '6px',
                      backgroundColor: '#E64D25',
                      color: '#fff',
                      border: 'none',
                      transition: 'background-color 0.3s ease',
                      userSelect: 'none'
                    }}
                  >
                    {copied ? "Copied!" : "Copy Code"}
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default HtmlColorCodes;
